import React, { useState } from 'react';

// =====================================================================
// 🚀 PANTALLA DE INICIO — una sola en toda la carga
// La misma pantalla se dibuja primero en public/index.html (HTML puro, antes
// de que cargue React) y después acá, en App y en ClientView, con las mismas
// clases (.bs-*, definidas en index.html). Así el cliente ve una única
// pantalla quieta que después se funde con la página, en vez de blanco →
// spinner → otra pantalla de carga.
//
// La barbería se recuerda en el teléfono (localStorage "cv-brand:<slug>"):
// desde la segunda visita, el logo y los colores aparecen al instante.
// =====================================================================

const TEMAS = {
  dark: { bg: '#1C1B19', surface: '#262421', line: 'rgba(255,255,255,0.09)', ink: '#F3F1EE' },
  light: { bg: '#EDEFF1', surface: '#FFFFFF', line: 'rgba(21,23,26,0.1)', ink: '#15171A' },
};

export const brandCacheKey = () => {
  const slug = typeof window !== 'undefined' ? window.location.pathname.split('/')[1] : '';
  return slug ? `cv-brand:${slug}` : null;
};

export const readBrandCache = () => {
  try {
    const key = brandCacheKey();
    return key ? JSON.parse(localStorage.getItem(key) || 'null') : null;
  } catch {
    return null;
  }
};

export const saveBrandCache = (brand) => {
  try {
    const key = brandCacheKey();
    if (key) localStorage.setItem(key, JSON.stringify(brand));
  } catch {
    // modo privado o almacenamiento bloqueado: sin caché, no pasa nada
  }
};

const BrandSplash = ({ shopName, logoUrl, brandColor, isDarkMode = true }) => {
  // Con datos en vivo se usan esos; si no, lo recordado de la última visita.
  const [cache] = useState(readBrandCache);
  const vivo = !!(shopName || logoUrl);
  const brand = vivo
    ? { name: shopName, logo: logoUrl, color: brandColor, dark: isDarkMode }
    : (cache || { dark: isDarkMode });
  const tema = TEMAS[brand.dark === false ? 'light' : 'dark'];

  // Las animaciones se sincronizan con el reloj de la página (desde que
  // empezó a cargar): cuando esta pantalla reemplaza a la de index.html, la
  // barra sigue exactamente donde iba, sin reiniciarse ni parpadear.
  const [t] = useState(() => (typeof performance !== 'undefined' ? performance.now() : 0));

  const hayMarca = !!(brand.logo || brand.name);

  return (
    <div className="bs-splash" role="progressbar" aria-label="Cargando"
      style={{
        '--bs-bg': tema.bg, '--bs-surface': tema.surface, '--bs-line': tema.line,
        '--bs-ink': tema.ink, '--bs-brand': brand.color || '#F59E0B',
      }}>
      {/* Delays negativos = la animación sigue donde iba la de index.html */}
      <div className="bs-stage" style={{ animationDelay: `${-t}ms` }}>
        {/* Logo con anillo que gira alrededor */}
        <div className="bs-orbit">
          <svg className="bs-ring" viewBox="0 0 132 132" fill="none" aria-hidden="true" style={{ animationDelay: `${-(t % 1150)}ms` }}>
            <circle className="pista" cx="66" cy="66" r="62" strokeWidth="2.5" />
            <circle className="arco" cx="66" cy="66" r="62" strokeWidth="2.5" strokeLinecap="round" strokeDasharray="90 300" />
          </svg>
          <div className="bs-mark">
            {brand.logo
              ? <img src={brand.logo} alt="" />
              : <span>{hayMarca ? brand.name.charAt(0) : 'B'}</span>}
          </div>
        </div>
        <div className="bs-name">
          {hayMarca ? (brand.name || '') : <>Barber<em>Go</em></>}
        </div>
      </div>
    </div>
  );
};

export default BrandSplash;
